import DetailProduct from '../components/DetailProduct'
const Detail = () => {
  return (
    <div className="pt-10">
      <DetailProduct />
    </div>
  )
}
export default Detail
